import {
  Navbar,
  NavLinks,
  NavLink,
} from "@/components/layout";
import { Button } from "@/components/ui/button";
import { useClientTranslation } from "@/hooks/use-client-translation";
import { LanguageToggle } from "@/components/language-toggle";
import { Link } from "react-router-dom";

/* -------------------------------------------------------------------------- */
/*                                   Logo                                     */
/* -------------------------------------------------------------------------- */

function Logo() {
  return (
    <Link to="/" className="flex items-center">
      <img 
        src="/mezepay-logo1.svg" 
        alt="MezePay" 
        className="h-11"
      />
    </Link>
  );
}

/* -------------------------------------------------------------------------- */
/*                              Site Header                                   */
/* -------------------------------------------------------------------------- */

interface SiteHeaderProps {
  /** Indicates which page is currently active for navigation highlighting */
  activePage?: 'home' | 'for-restaurants' | 'solutions' | 'integrations' | 'blog';
}

export function SiteHeader({ activePage }: SiteHeaderProps = {}) {
  const { t } = useClientTranslation();

  const handleContactClick = (e: React.MouseEvent) => {
    e.preventDefault();
    window.open("mailto:info@mezepay.com", "_self");
  };

  return (
    <Navbar
      logo={<Logo />}
      links={
        <NavLinks>
          <NavLink 
            href="/"
            active={activePage === 'home'}
          >
            {t("nav.howItWorks")}
          </NavLink>
          <NavLink
            href="/for-restaurants"
            active={activePage === 'for-restaurants'}
          >
            {t("nav.forRestaurants")}
          </NavLink>
          <NavLink
            href="/solutions"
            active={activePage === 'solutions'}
          >
            {t("nav.solutions")}
          </NavLink>
          <NavLink
            href="/integrations"
            active={activePage === 'integrations'}
          >
            {t("nav.integrations")}
          </NavLink>
          <NavLink
            href="/blog"
            active={activePage === 'blog'}
          >
            {t("nav.blog")}
          </NavLink>
        </NavLinks>
      }
      actions={
        <div className="flex items-center gap-2">
          <LanguageToggle />
          <Button
            className="hidden md:inline-flex bg-gradient-to-r from-purple-primary to-yellow-accent text-white rounded-full px-5 py-2 text-base font-medium"
            onClick={handleContactClick}
          >
            {t("hero.contact")}
          </Button>
        </div>
      }
    />
  );
}
